import { httpClient } from '../util/http-client'

export const fetchByDomain = async (url: string, domain: string) => {
  const { data } = await httpClient(url, { domain })

  return data.list
}
